import axios from "axios";

const state = {
  postagens: []
};

//Acesso ao state
const getters = {
  allPostagens: state => state.postagens,
};

const actions = {
  //Disparando para a API a requisição GET
  getPostagens({ commit }) {
    axios.get(
      "https://my-json-server.typicode.com/anathsu/vue-json-api/dados"
    ).then((response) => {
      //Envio para getPostagens da mutations a resposta da API
      commit('getPostagens', response.data);
    });
  },
  addPostagem({ commit }, postagem) {
    commit('addPostagem', postagem)
  },
  deletePostagem({ commit }, id) {
    commit('deletePostagem', id)
  },
  updatePostagem({ commit }, updPostagem) {
    commit("updatePostagem", updPostagem);
  },

}

//Insiro no state as respostas da API
const mutations = {
  //Pego a resposta da api e passo para o state
  getPostagens: (state, data) => (state.postagens = data),

  //Adicionando um usuário
  addPostagem: (state, data) => state.postagens.push(data),

  //deletando um usuário
  deletePostagem: (state, id) => (state.postagens = state.postagens.filter(p => p.id !== id)),

  updatePostagem: (state, data) => {
    const index = state.postagens.findIndex(t => t.id === data.id)
    if (index !== -1) {
      state.todos.splice(index, 1, data);
    }
  }
}

export default {
  state,
  actions,
  getters,
  mutations
};